export default __webpack_public_path__ + "static/media/_fire.9cf02a7d.jpg";